export enum CreateIntegrationEvent {
  OnViewInit = 'createIntegrationOnViewInit',
  OnCompanySelect = 'onCompanySelect',
  OnShowRequirements = 'onShowRequirements',
  OnValidDataCompletion = 'OnValidDataCompletion',
  OnInValidDataCompletion = 'OnInValidDataCompletion',
  OnWindowCancel = 'OnWindowCancel',
  OnLicenseAdd = 'OnLicenseAdd',
  OnSwitchToSelectType = 'OnSwitchToSelectType',
  OnLicenseChanged = 'OnLicenseChanged',
  CreateCompanySelector = 'CreateCompanySelector',
  OnModifyDialogTitle = 'OnModifyDialogTitle',
  OnShowTechnicalRequest = 'OnShowTechnicalRequest',
  OnShowInformationAboutIntegration = 'OnShowInformationAboutIntegration',
}
